import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import CancelService from './CancelService'
import {
  getServices as getBookings
} from '@src/redux/modules/entities'
import {
  fetch as fetchBooking,
  cancel as cancelBooking,
  isFetching as isFetchingBooking,
  isCancelling as isCancellingBooking
} from '@src/redux/modules/service'

const getBooking = (bookings, bookingId) => bookings[bookingId]

const mapStateToProps = (state, ownProps) => {
  const { serviceId: bookingId } = ownProps.params
  const bookings = getBookings(state)
  const booking = getBooking(bookings, bookingId)

  const fetchingBooking = isFetchingBooking(state)
  const cancellingBooking = isCancellingBooking(state)

  return {
    bookingId: parseInt(bookingId),
    booking,
    fetchingBooking,
    cancellingBooking
  }
}

const mapDispatchToProps = {
  fetchBooking,
  cancelBooking,
  push
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelService)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/CancelService/CancelServiceContainer.js